
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h24v24H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M12 13a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 019 10c0-.833.292-1.542.875-2.125A2.893 2.893 0 0112 7c.833 0 1.542.292 2.125.875S15 9.167 15 10s-.292 1.542-.875 2.125A2.893 2.893 0 0112 13zM6 23v-7.725a7.707 7.707 0 01-1.475-2.4A7.862 7.862 0 014 10c0-2.233.775-4.125 2.325-5.675C7.875 2.775 9.767 2 12 2c2.233 0 4.125.775 5.675 2.325C19.225 5.875 20 7.767 20 10a7.862 7.862 0 01-.525 2.875c-.35.9-.842 1.7-1.475 2.4V23l-6-2-6 2zm6-7c1.667 0 3.083-.583 4.25-1.75C17.417 13.083 18 11.667 18 10c0-1.667-.583-3.083-1.75-4.25C15.083 4.583 13.667 4 12 4c-1.667 0-3.083.583-4.25 1.75C6.583 6.917 6 8.333 6 10c0 1.667.583 3.083 1.75 4.25C8.917 15.417 10.333 16 12 16z"}})])])
          )
        }
      }
    